// import styling
import './Footer.scss';

function Footer() {
    return (
        <div className='footer-wrapper'>
            <div>
                Icons made by{' '}
                <a href='https://www.flaticon.com/authors/freepik' title='Freepik'>
                    Freepik
                </a>{' '}
                from{' '}
                <a href='https://www.flaticon.com/' title='Flaticon'>
                    www.flaticon.com
                </a>
            </div>
        </div>
    );
}

export default Footer;
